import { Provider } from 'react-redux';
import { AppRouter } from './components/AppRouter';
import {store} from './store/store';
import './App.scss';

function App() {
  return (
    <>
      <Provider store={store}>
        <AppRouter/>
      </Provider>
    </>
  );
}

export default App;
